export default {
  SITE_NAME: 'TexBadge',
  HELP_DESK_PHONE: '1-877-452-9060'
};
